<template>
    <div class="home-component">
        <div class="app-header">
            <img class="session-detail-component-header-logo" src="./../assets/elevate-logo.png" alt="Elevate logo" height="150">
        </div>

        <div class="enter-membership-form">
            <div class="member-log-in-title">
                    パスワードをリセットする
                </div>

                <div class="membership-input">
                    <div class="membership-number-text-field-label">
                    Email
                </div>
                <div class="membership-number-text-field-container">
                    <input class="membership-number-text-field" id="membership-number-text-field">
                </div>
            </div>

            <div class="button-container">
                <button type="button" @click="forgotPassword()" id="reset-pw-button" class="membership-number-submit">送信する </button>
            </div>
        </div>
        
    </div>
</template>

<style scoped>
    .home-component {
        min-height: calc(100vh - 110px);
        display: flex;
        align-items: center;
        justify-content: top;
        flex-direction: column;
        background: rgb(34, 32, 37);
        padding-top: 50pt;
        background-image: url("./../assets/elevate-tiling.png");
    }

    .waiver-link {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 14pt;
    }

    .button-container {
        display: flex;
         justify-content: center;
         margin-top: 35pt;
    }

    .session-detail-component-header-logo {
        width: 100%;
        height: 120pt;
        object-fit: contain;
    }

    .app-header {
        height: 100pt;
        display: flex;
        justify-content: left;
        align-items: left;
    }

    .enter-membership-form {
        align-items: center;
        justify-content: center;
        max-width: 400px;
        margin-left: 20px;
        margin-right: 20px;
    }
    .membership-number-text-field {
        height: 35px;
        font-family:  SFPRoRegular;
        font-size: 14pt;
        box-sizing: border-box;
    }

    .home-component-elevate-title {
        font-family: SFPRoBold;
        font-size: 16pt;
    }

    .membership-number-text-field-label {
        font-family: SFPRoBold;
        color: white;
        padding-top: 15pt;
    }

    .membership-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .password-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .membership-number-text-field-sub-label {
        font-family: SFPRoRegular;
        color: white;
        font-size: 12pt;
        margin-bottom: 20pt;
        margin-top: 4pt;
    }

    .membership-number-submit {
        height: 40px;
        background-color: rgb(225, 228, 99);
        cursor: pointer;
        border: none;
        border-radius: 8px;
        color: black;
        font-family: SFPRoBold;
        font-size: 16px;
        transition: 300ms;
        width: 150pt;
        align-items: center;
        justify-content: center;
    }

.sign-up-for-membership-page {
    font-family: SFPRoRegular;
    color: white;
    font-size: 14pt;
    margin-top: 5pt;
}

.member-log-in-title {
    font-family: SFPRoBold;
    color: white;
    font-size: 18pt;
    margin-top: 50pt;
    text-align: left;
    display: flex;
}

</style>


<script setup>
    import NProgress from 'nprogress';
    import 'nprogress/nprogress.css';
    import { getAuth, sendPasswordResetEmail } from "firebase/auth";

    function forgotPassword() { 
        //TODO: check if user came from event, if so show that event.

        const userEmail = document.getElementById('membership-number-text-field').value;
       
        NProgress.start();
        const auth = getAuth();

        document.getElementById("reset-pw-button").disabled = true;
        sendPasswordResetEmail(auth, userEmail)
        .then(() => {
            document.getElementById("reset-pw-button").disabled = false;
            alert("アカウント登録に使用したEmailに、パスワード再設定リンクが届きます。確認できない場合は、迷惑メールフォルダをご確認ください。")
            NProgress.done();
        })
        .catch((error) => {
            document.getElementById("reset-pw-button").disabled = false;
            const errorCode = error.code;
            const errorMessage = error.message;
            alert(errorMessage)
            NProgress.done();
    });
     } 
</script>

<script>
export default {
    mounted () {
        window.scrollTo(0, 0);
    }
}
</script>